/** EN uses Swedish values until translated. */
export const pagesCompaniesEn = {
    filters: {
        showAllCompanies: 'All companies',
        onlyListedCompanies: 'Only listed companies',
        onlyDelistedCompanies: 'Only delisted companies',
        delistedLabel: 'Delisted',
        marketCap: 'Market cap',
    },
    delistedSince: '(Delisted since {{date}})',
    orgNumber: 'Org.nr',
    totalShares: 'Total amount of shares',
    marketCap: 'Market cap',
    tooltips: {
        totalShares: 'The total number of shares for all share classes plus maximum dilution from current issues.',
        marketCap: 'Market cap is based on the total number of shares plus maximum dilution from current issues.',
        registeredShares: 'Number of registered shares per share class. The definition may vary for e.g. dual-listed shares. Source: Millistream',
    },
    shareN: 'Share {{n}}',
    listing: 'Marketplace',
    numberOfShares: 'Number of shares',
    delisted: 'Delisted',
    shareDelistedSince: 'The share is delisted since {{date}}',
    pressReleases: 'Press releases',
    pressRelease: {
        error: 'Something went wrong, press releases could not load.',
        listView: 'List view',
        linkMode: 'Attach',
        linkedFiles: 'Linked files',
        relatedTransactions: 'Related transactions',
    },
    vwap: {
        days: 'Days',
        change: 'Change',
        vwapDays: 'VWAP {{n}} days',
        turnoverPerDay: 'Turnover / day',
    },
    currentTransactions: {
        empty: 'No current or upcoming share issues, warrants or convertible loans',
        title: 'Current issues, warrants and convertibles',
        subscriptionPrice: 'Sub price',
    },
    guarantorIssue: 'Guarantor issue',
    abbDirectedIssue: 'Accelerated book building',
    convertibleLoans: 'Convertible loan',
    loan: 'Loan',
    terms: 'Terms',
    outstandingLoanAmount: 'Outstanding loan amount in {{currency}}',
    noConvertiblesFound: 'No convertibles found',
    history: {
        title: 'History',
        adjustForSplits: 'Adjust for splits',
        event: 'Event',
        subscribedShares: 'Subscribed shares',
        amountInCurrency: 'Amount in {{currency}}',
        bonusIssue: 'Bonus issue {{new}}:{{old}}',
        stockSplit: 'Split {{new}}:{{old}}',
        nameChange: 'Name change from {{from}} to {{to}}',
        zeroNewShares: '0 new shares',
        overAllotment: 'Overallotment',
        existingShares: 'Secondary shares',
        overAllotmentExisting: 'Overallotment secondary',
        directedIssueToGuarantors: 'Directed issue to guarantors',
        delistingOf: 'Delisting of {{name}}',
        listingOf: 'Listing of {{name}}',
        stockSplitLabel: 'Split',
        bonusIssueLabel: 'Bonus issue',
    },
    changeDate: 'Change date',
    share: 'Share',
    btaBtu: 'BTA/BTU',
    rights: 'Rights',
    volume: 'Volume',
    graph: {
        closePrice: 'Close price',
        vwap: 'VWAP',
        turnoverSek: 'Turnover (SEK)',
        tradedProportion: 'Turnover (%)',
        timeRange: {
            oneMonth: '1 m',
            threeMonths: '3 m',
            yearToDate: 'YTD',
            oneYear: '1 y',
            threeYears: '3 y',
            max: 'max',
        },
        timeIntervalAria: 'Time interval',
        settings: 'Settings',
        selectSeries: 'Choose series',
        selectBars: 'Choose bars',
        smoothLine: 'Softened lines',
        clickEventHint: 'Click an event in the graph to view details',
        tooltip: {
            mcap: 'Mcap',
            close: 'Close',
            change: 'Perf',
            turnover: 'Turnover',
            shares: 'Shares',
        },
    },
    tabs: {
        aboutShare: 'About share',
        aboutCompany: 'About company',
        selectedEvent: 'Selected event',
    },
}
